import { render } from "./ClientEditPayoutForm.vue?vue&type=template&id=971a9d36&scoped=true"
import script from "./ClientEditPayoutForm.vue?vue&type=script&lang=js"
export * from "./ClientEditPayoutForm.vue?vue&type=script&lang=js"

import "./ClientEditPayoutForm.vue?vue&type=style&index=0&id=971a9d36&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-971a9d36"]])

export default __exports__